module.exports = __webpack_public_path__ + "static/media/30-49men.c6a1e019.svg";